import React from 'react';
import PropTypes from 'prop-types';
import {ExceptionalTimeSpan} from './ExceptionalTimes.style';
import {convertExceptionalTime, convertExceptionalTimeDay, isEqual} from '../../helpers/date.helper';
import {FormattedMessage} from 'react-intl';
import {H4} from '../../styles/components/typography.style';

const ExceptionalTimes = props => {
  const { restaurant, opening } = props;
  const times = opening ? restaurant.exceptionalOpeningTimes : restaurant.exceptionalClosingTimes;

  return (
    <div>
      <H4 bold={true}><FormattedMessage id={opening ? 'contact.openDays' : 'contact.closedDays'} /></H4>
      {times.map((item, index) => (
        <p key={item.description + index}>
          <ExceptionalTimeSpan>{item.description}</ExceptionalTimeSpan>
          <span>{convertExceptionalTimeDay(item.fromDay)}</span>
          {!isEqual(item.fromDay, item.toDay) && <span> - {convertExceptionalTimeDay(item.toDay)}</span>}
          {opening && <ExceptionalTimeSpan>{convertExceptionalTime(item.fromTime)} - {convertExceptionalTime(item.toTime)}</ExceptionalTimeSpan>}
        </p>)
      )}
    </div>
  );
};

ExceptionalTimes.propTypes = {
  restaurant: PropTypes.object.isRequired,
  opening: PropTypes.bool.isRequired
};

export default ExceptionalTimes;



// WEBPACK FOOTER //
// ./components/ExceptionalTimes/ExceptionalTimes.js